<template>
  <svg
    :width="`${width}px`"
    :height="`${height}px`"
    viewBox="0 0 21 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :class="['star', `star--${variant}`]"
    v-on="$listeners"
  >
    <polygon
      :class="[
        'star__polygon',
        {
          'star__polygon--inactive': isInactive,
          'star__polygon--empty': hasBorderOnly,
          'star__polygon--alert': hasAlert,
        },
      ]"
      points="11.1,15.4 5.5,18.3 6.5,12.1 2,7.7 8.3,6.8 11.1,1.2 13.9,6.8 20.2,7.7 15.7,12.1 16.7,18.3"
    ></polygon>
  </svg>
</template>

<script>
export const VARIANTS = {
  default: 'default',
  small: 'small',
  large: 'large',
}

export default {
  name: 'IconStar',

  props: {
    isInactive: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: VARIANTS.default,
      validator(value) {
        return Object.values(VARIANTS).includes(value)
      },
    },
    hasBorderOnly: {
      type: Boolean,
      default: false,
    },
    hasAlert: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    width() {
      if (this.variant === VARIANTS.small) return 17
      // in viewBox: 21
      else if (this.variant === VARIANTS.large) return 29
      else return 24
    },

    height() {
      if (this.variant === VARIANTS.small) return 15
      // in viewBox: 19
      else if (this.variant === VARIANTS.large) return 29
      else return 21
    },
  },
}
</script>

<style lang="scss" scoped>
$active-color: $color-grey-dark-2;
$inactive-color: $color-grey-mid-2;

.star {
  & + & {
    margin-left: 7px;

    &--small {
      margin-left: 4px;
    }
  }

  &__polygon {
    stroke: $active-color;
    stroke-width: 1;
    fill: $active-color;
    transition: fill $transition-time-fast;

    &--inactive {
      stroke: $inactive-color;
      fill: $inactive-color;
    }

    &--empty {
      stroke: $inactive-color;
      fill: transparentize($active-color, 1);
    }

    &--alert {
      stroke: $color-red;
    }
  }
}
</style>
